<template>

<div class="recommend">

    <div class="grid">

        <RecommendCard

            v-for="item in list"

            :key="item.id"

            :item="item"

            @click="$emit('detail',item)"

        />

    </div>

</div>

</template>

<script setup>

import RecommendCard from "./RecommendCard.vue"

defineProps({

    list:{

        type:Array,

        default:()=>[]

    }

})

defineEmits([

"change",

"detail"

])

</script>

<style scoped lang="less">


.header{

display:flex;

justify-content:space-between;

align-items:center;

margin-bottom:24px;

}

.title{

font-size:22px;

font-weight:700;

}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

</style>